exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.selectable-vans-results{\n    background-color: white;\n    border: solid 1px #f5f5f5;\n    width: auto;\n    min-width: 20rem;\n    max-height: 10rem;\n    overflow-y: auto;\n    position: absolute;\n    z-index: 1;\n}\n.selectable-vans-list {\n  list-style-type: none;\n}\n.selectable-vans-list li {\n    cursor: pointer;\n    padding: 3px;\n}\n.selectable-vans-list li:hover {\n    background-color: #f5f5f5;\n}\n", ""]);

// exports
